import classNames from 'classnames/bind';
import React from 'react';

import MapView from './01_MapView';
import PhotosOverlay from './02_PhotosOverlay';
import styles from './index.module.scss';

import SettingsModal from '@/components/modals/Settings';
import { FunctionButton } from '@/components/ui/kit/Button';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Options = ({ robot }) => {
  const openSettings = () => {
    modalManager.show(SettingsModal, { robot });
  };

  return (
    <div className={cx('container')}>
      <MapView robotId={robot.id} />
      <PhotosOverlay robotId={robot.id} />
      {robot.isOwned && <FunctionButton text="Open Settings" onClick={openSettings} className={cx('button')} />}
    </div>
  );
};

export default Options;
